export default "/assets/graph-placeholder.svg";